import { foundations } from '../foundations';
const { colors } = foundations;

export const Stack = {
  variants: {
    bordered: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      container: {
        border: `1px solid ${colors.border.transparent[colorMode]}`,
        shadow: 'none',
      },
    }),
  },
};
